
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    isLoadingGetKYFormSubmissions: false,

    formSubmissionList: [],
    formSubmissionListQuantity: null,

};

//! sıra listesi 
export const getKYFormSubmissions = createAsyncThunk("kamyoonRoad/getKYFormSubmissions", async (_, thunkApi) => {
    try {
      const {data} = await axiosInstance.get(`/KamyoonYollarda/FormSubmissions?page=${1}`)


      return data.data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


const kamyoonRoadSlice = createSlice({
  name: "kamyoonRoad",
  initialState,
  reducers: {
  },

  extraReducers: (builder) => {
    builder

      .addCase(getKYFormSubmissions.pending, (state) => {
        state.isLoadingGetKYFormSubmissions = true
      })
      .addCase(getKYFormSubmissions.fulfilled, (state, action) => {
        state.isLoadingGetKYFormSubmissions = false
        state.formSubmissionList = action.payload.items.$values
        state.formSubmissionListQuantity = action.payload.count

      })
      .addCase(getKYFormSubmissions.rejected, (state, action) => {
        state.isLoadingGetKYFormSubmissions = false

      })

  }
});

export const {
} = kamyoonRoadSlice.actions

export default kamyoonRoadSlice.reducer;
